import { getFermentationSteps } from "@util/recipeHelper";
import { VALIDATION } from "@common/constants/recipeConstants";

const SERVING_MIN = 1,
  SERVING_MAX = 15;

// Keg fermentation-control envelope — the same bound the Custom sliders
// enforce (EditFermentationModal 5–35 °C). The recipe EDITOR allows up to
// 40 °C because brews chill on the base; a keg cannot hold that.
const STEP_MIN = VALIDATION.KEG_FERM_STEP_MIN,
  STEP_MAX = VALIDATION.KEG_FERM_STEP_MAX;

export function fermentationSummary(recipe) {
  return getFermentationSteps(recipe).map((step) => ({
    stageName: step.stageName,
    temperature: Number(step.temperature),
    endTemperature:
      step.end_temperature != null ? Number(step.end_temperature) : null,
    // The recipes API serializes fermentation step duration in DAYS, not minutes
    // (recipes/v1/serializers.py get_duration divides by 60/24 for fermenting steps).
    durationDays: Number(step.duration),
  }));
}

export function recipeFitsKeg(recipe) {
  const rows = fermentationSummary(recipe);
  if (!rows.length) {
    return { ok: false, reason: "This recipe has no fermentation schedule." };
  }
  for (const row of rows) {
    const temps = [row.temperature].concat(
      row.endTemperature != null ? [row.endTemperature] : [],
    );
    for (const t of temps) {
      if (!(t >= STEP_MIN && t <= STEP_MAX)) {
        return {
          ok: false,
          reason: `Fermentation step at ${t} °C is outside the keg range (${STEP_MIN}–${STEP_MAX} °C).`,
        };
      }
    }
  }
  const serving = Number(recipe.serving_temperature);
  if (!(serving >= SERVING_MIN && serving <= SERVING_MAX)) {
    return {
      ok: false,
      reason: `Serving temperature ${serving} °C is outside the keg range (${SERVING_MIN}–${SERVING_MAX} °C).`,
    };
  }
  return { ok: true, reason: null };
}
